// A tiny dismiss hook for the top-bar popovers (appearance + account). While
// the menu is OPEN, a pointer-down outside the control or an Escape key closes
// it; the ref wraps the WHOLE control (trigger + panel) so clicking the trigger
// to toggle doesn't immediately re-close. No-op while closed (no listeners).

import { useEffect, type RefObject } from "react";

export function useOutsideClose<T extends HTMLElement>(
  open: boolean,
  ref: RefObject<T | null>,
  onClose: () => void,
): void {
  useEffect(() => {
    if (!open) return;
    function onPointerDown(e: PointerEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    // Capture phase so we see the press even if a child stops propagation.
    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown, true);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, ref, onClose]);
}
